import { updateCookies, updateProfileInformation } from './cities';
import { fetchData } from './fetch';

export const checkResponseData = (data) =>{
  return (
    typeof data === 'object' &&
    data !== null &&
    'title' in data &&
    'text' in data &&
    'imageUrl' in data
  );
}

export const setMaintenanceInfo = (title, text, imageUrl) => {
  const maintenanceImage = document.querySelector('.popup-header-logo.maintenance.src'); 
  const maintenanceTitle = document.querySelector('.popup-title.maintenance');
  const maintenanceDescription = document.querySelector(
    '.popup-description.maintenance',
  ); 
  const maintenanceDopImage = document.querySelector(
    '.svg-icon.maintenance'
  ); 

  if (imageUrl) {
    maintenanceImage.src = imageUrl;
    if (maintenanceImage.classList.contains('hidden')) maintenanceImage.classList.remove('hidden');
    maintenanceDopImage.classList.add('hidden');
  }
  else {
    if (maintenanceDopImage.classList.contains('hidden'))
      maintenanceDopImage.classList.remove('hidden');
    maintenanceImage.classList.add('hidden');
  }

  maintenanceTitle.textContent = title || 'Сайт временно недоступен';
  maintenanceDescription.textContent = text || '';
};

export const handleMaintenancePopup = async (
  cityId,
  cityName,
  page,
) => {
  const maintenancePopup = document.getElementById('maintenance');
  const cityMaintenanceInput = document.getElementById(
    'city-maintenance-input',
  );
  const maintenanceLoading = document.querySelector('.maintenance-loading');
  const maintenanceInputWrapper = document.querySelector(
    '.input-wrapper-maintenance',
  );
  const cityMaintenanceList = document.getElementById('city-maintenance-list');
  const deliverySelectionPopup = document.querySelector(
    '#delivery-selection-popup',
  );

  const maintenanceListElements = document.querySelectorAll('.city-list-elem');
  const userNameInput = document.querySelector('.user-name');
  const citiesPopup = document.querySelector('.cities-popup-wrapper');
  const citiesLoading = document.querySelector('.cities-loading');

  if (citiesLoading) citiesLoading.classList.remove('visible');


  if (maintenancePopup) {
    if (deliverySelectionPopup?.classList.contains('active')) 
      deliverySelectionPopup.classList.remove('active');
    maintenancePopup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  if (maintenanceInputWrapper){
    maintenanceInputWrapper.addEventListener('click', () => {
      if (window.innerWidth < 895) {
        const citiesPopupA = citiesPopup.querySelector('a.popup-header.row');
        citiesPopupA.style.display = 'none';
        citiesPopup.classList.add('active');
        citiesPopup.style.zIndex = 30;
      }
      else 
        cityMaintenanceList.style.display =
        cityMaintenanceList.style.display === 'flex' ? 'none' : 'flex';
    });
  }

  if (cityMaintenanceInput) {
      cityMaintenanceInput.dataset.id = cityId;
  }

  if (maintenanceListElements){
    maintenanceListElements.forEach((maintenance) =>{
      maintenance.addEventListener('click', async () => {
        if (maintenanceLoading) maintenanceLoading.classList.add('visible');
        
        cityMaintenanceList.style.display = 'none';

        const newCityId = maintenance.getAttribute('value');

        const response = await fetchData(
          `/v1/maintenance/enabled?cityId=${newCityId}`,
        );

        if (checkResponseData(response.data)) {
          if (maintenanceLoading) maintenanceLoading.classList.remove('visible');
          setMaintenanceInfo(
            response.data.title,
            response.data.text,
            response.data.imageUrl,
          );

          cityMaintenanceInput.dataset.id = maintenance.value;
          cityMaintenanceInput.textContent = maintenance.textContent;
        }
        else {
          cityId = newCityId;
          cityName = maintenance.dataset.name;

          updateCookies(cityId);

          localStorage.setItem('isContentAvailable', true);

          await updateProfileInformation(
            cityId,
            userNameInput.value,
            page,
            cityName,
          );
        }
    });
  })}
  };
